import React from 'react';
import { Table, Grid, Card, List, Descriptions, Tag, Tooltip } from 'antd';
import { ReserveStatus } from './ReserveStatus';
import { FoodAndParkingStatus } from './FoodAndParkingStatus';

const { useBreakpoint } = Grid;

 const tableCellStyle = {
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        lineHeight: '1.5',
        padding: '8px 4px',
    };

const descriptionItemStyle = {
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    minWidth: '100%',
};

export const ReservesGrid = ({
    reserves,
    mode,
    onlyByFoodOrParking = false,
    objectInstance,
    onItemClick,
    currentSortColumn,
    currentSortOrder,
    onTableChange,
    currentPage,
    pageSize,
}) => {
    // انتقال هوک به داخل کامپوننت
    const screens = useBreakpoint();
    const isMobile = !screens.md;

    const sortedInfo = {
        columnKey: currentSortColumn,
        order: currentSortOrder,
    };

    const handleChange = (pagination, filters, sorter) => {
        onTableChange(pagination, filters, sorter);
    };

    const getColumnSorter = (dataIndex) => {
        const columnKey = Array.isArray(dataIndex) ? dataIndex.join('.') : dataIndex;
        return {
            sorter: true,
            sortOrder: sortedInfo.columnKey === columnKey ? sortedInfo.order : undefined,
        };
    };

    const isReserveInPast = (record) => {
    if (!record?.from) return false; // اگر فیلد تاریخ میلادی دارید
    const reserveDate = new Date(record.from);
    const today = new Date();
    return reserveDate < today;
};

const expandedRowRender = (record) => {
    const totalPersons = record?.reserve_Users?.length || 0; // ✅ استفاده از روش جدید

    return (
        <Descriptions bordered column={{ xs: 1, sm: 2, md: 3 }} size="small" style={{ margin: '16px 0' }}>
            <Descriptions.Item label="دوره" style={descriptionItemStyle}>
                <Tag color="blue">{record?.period?.title || "نامشخص"}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="زیردوره" style={descriptionItemStyle}>
                <Tag color="geekblue">{record?.subPeriod?.title || "نامشخص"}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="نفرات" style={descriptionItemStyle}>
                <Tag color="green">{totalPersons} نفر</Tag> {/* ✅ به روز شده */}
            </Descriptions.Item>
            <Descriptions.Item label="تعداد شب" style={descriptionItemStyle}>
                <Tag color="purple">{record?.factor?.nightCount || 0} شب</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="وضعیت رزرو غذا" style={descriptionItemStyle}>
                <FoodAndParkingStatus foodAndParkingStatus={record.foodAndParkingStatus} />
            </Descriptions.Item>
            {/* <Descriptions.Item label="تعداد پارکینگ" style={descriptionItemStyle}>
                <Tag color="orange">{record?.Parking?.count || 0}</Tag>
            </Descriptions.Item> */}
        </Descriptions>
    );
};

    const columns = [
  {
    title: 'ردیف',
    key: 'rowNumber',
    align: 'center',
    width: 70,
    responsive: ['sm', 'md', 'lg', 'xl'],
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'پیگیری',
    dataIndex: 'trackingCode',
    key: 'trackingCode',
    // width: 120, // ❌ حذف width ثابت
    ellipsis: false, // ✅ اجازه نمایش کامل
    responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    ...getColumnSorter('trackingCode'),
  },
   {
    title: 'مکان',
    dataIndex: ['objectInstance','title'],
    key: 'objectInstance.title',
    ellipsis: false,
    render: (title, record) => (
      <Tooltip placement="topLeft" title={title || (objectInstance ? objectInstance.title : 'نامشخص')}>
        <span style={{ whiteSpace: 'normal' }}>
          {title || (objectInstance ? objectInstance.title : 'نامشخص')}
        </span>
      </Tooltip>
    ),
    ...getColumnSorter(['objectInstance','title']), // ✅ سورت فعال
  },
  {
    title: 'کد ملی',
    dataIndex: 'nationalCode',
    key: 'nationalCode',
    // width: 140, // ❌ حذف width ثابت
    ellipsis: false,
    responsive: ['md', 'lg', 'xl'],
    ...getColumnSorter('nationalCode'),
  },
  {
    title: 'نفر اصلی',
    dataIndex: 'fullName',
    key: 'fullName',
    // width: 160, // ❌ حذف width ثابت
    ellipsis: false,
    responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    render: (text) => <span style={{ whiteSpace: 'normal' }}>{text}</span>, // ✅ چندخطی
    ...getColumnSorter('fullName'),
  },
  {
    title: 'موبایل',
    dataIndex: 'mobile',
    key: 'mobile',
    // width: 130, // ❌ حذف width ثابت
    ellipsis: false,
    responsive: ['sm', 'md', 'lg', 'xl'],
    ...getColumnSorter('mobile'),
  },
  {
    title: 'شروع اقامت',
    dataIndex: 'from_Shamsi',
    key: 'from_Shamsi',
    // width: 120, // ❌ حذف width ثابت
    ellipsis: false,
    responsive: ['md', 'lg', 'xl'],
    ...getColumnSorter('from_Shamsi'),
  },
  {
    title: 'پایان اقامت',
    dataIndex: 'to_Shamsi',
    key: 'to_Shamsi',
    // width: 120, // ❌ حذف width ثابت
    ellipsis: false,
    responsive: ['md', 'lg', 'xl'],
    ...getColumnSorter('to_Shamsi'),
  },
   {
  title: 'دوره',
  dataIndex: ['period','title'],
  key: 'period.title',
  ellipsis: false,
  responsive: ['md', 'lg', 'xl'],
  render: (title) => (
    <span style={{ whiteSpace: 'normal' }}>
      {title || 'نامشخص'}
    </span>
  ),
  ...getColumnSorter('period.title'),
},

  {
  title: 'نفرات',
  key: 'totalPersons',
  align: 'center',
  responsive: ['xs','sm','md','lg','xl'],
  render: (_, record) => (
    <span style={{ whiteSpace: 'normal' }}>
      {record?.reserve_Users?.length || 0}
    </span>
  ),
    ...getColumnSorter('totalPersons'), // ✅ سورت بر اساس منطق سرور (فاکتورها)
},
  {
    title: 'وضعیت غذا',
    dataIndex: 'foodAndParkingStatus',
    key: 'foodAndParkingStatus',
    // width: 120, // ❌ حذف width ثابت
    responsive: ['lg','xl'],
    render: (v) => <div style={{ whiteSpace: 'normal' }}><FoodAndParkingStatus foodAndParkingStatus={v} /></div>,
    ...getColumnSorter('foodAndParkingStatus'),
  },
  {
    title: 'وضعیت رزرو',
    dataIndex: 'reserveStatus',
    key: 'reserveStatus',
    // width: 140, // ❌ حذف width ثابت
    responsive: ['sm','md','lg','xl'],
    render: (status) => <div style={{ whiteSpace: 'normal' }}><ReserveStatus reserveStatus={status} /></div>,
    ...getColumnSorter('reserveStatus'),
  },
];

const filteredReserves = onlyByFoodOrParking
        ? reserves.filter(reserve => reserve.period?.enableFoodReserve || reserve.period?.enableParkingReserve)
        : reserves;

    return (
        <div className="container">
            {isMobile ? (
                <List
    dataSource={filteredReserves}
    renderItem={(item, index) => {
        const totalPersons = item?.reserve_Users?.length || 0; // ✅ استفاده از روش جدید
        const isPast = isReserveInPast(item);
        return (
            <Card
                key={item.id}
                onClick={() => onItemClick?.(item.id)}
                style={{ 
                    marginBottom: 12, 
                    cursor: onItemClick ? 'pointer' : 'default',
                    backgroundColor: isPast ? '#f8f9fa' : 'inherit', // اضافه کردن رنگ زمینه
                    opacity: isPast ? 0.7 : 1
                }}
                className={
                    (item.lotteryPriority == 1 ? 'successRow valueRow' : 
                     item.lotteryPriority > 1 ? 'failRow valueRow' : 'valueRow') +
                    (isPast ? ' past-reserve' : '')
                }
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                    <strong>{index + 1}. {item.fullName}</strong>
                    <ReserveStatus reserveStatus={item.reserveStatus} />
                </div>
                <div>پیگیری: {item.trackingCode}</div>
                <div>مکان: {item?.objectInstance?.title || objectInstance?.title || 'نامشخص'}</div>
                <div>تاریخ: {item.from_Shamsi} تا {item.to_Shamsi}</div>
                <div>نفرات: {totalPersons}</div> {/* ✅ به روز شده */}
                <FoodAndParkingStatus foodAndParkingStatus={item.foodAndParkingStatus} />
            </Card>
        );
    }}
/>

            ) : (
                <Table
                    columns={columns}
                    dataSource={filteredReserves}
                    rowKey="id"
                    onChange={handleChange}
                    pagination={false}
                    expandable={{ expandedRowRender }}
                    tableLayout="auto" // ✅ مهم: auto برای تنظیم خودکار
                    size="middle"
                    className="responsive-table" // ✅ برای استایل‌دهی اضافی

                    
                    onRow={(record) => {
        const isPast = isReserveInPast(record); // ✅ تعریف isPast
        
        return {
            onClick: () => onItemClick?.(record.id),
            style: onItemClick ? { cursor: 'pointer' } : {},
            className: 
                (record.lotteryPriority == 1 ? 'successRow valueRow' : 
                 record.lotteryPriority > 1 ? 'failRow valueRow' : 'valueRow') +
                (isPast ? ' past-reserve' : '')
        };
    }}
/>
            )}
        </div>
    );
};





// import React, { useState } from 'react';
// import { Table, Button, Space, Descriptions, Tag } from 'antd'; // Tag هم اضافه شد برای زیبایی
// import { ReserveStatus } from './ReserveStatus';
// import { FoodAndParkingStatus } from './FoodAndParkingStatus';

// const tableCellStyle = {
//     wordWrap: 'break-word',
//     wordBreak: 'break-word',
// };

// export const ReservesGrid = ({
//     reserves,
//     onlyByFoodOrParking = false,
//     objectInstance,
//     onItemClick,
// }) => {
//     const [sortedInfo, setSortedInfo] = useState({});

//     const handleChange = (pagination, filters, sorter) => {
//         setSortedInfo(sorter);
//     };

//     const getColumnSorter = (dataIndex) => {
//         const columnKey = Array.isArray(dataIndex) ? dataIndex.join('.') : dataIndex;

//         return {
//             sorter: (a, b) => {
//                 let aValue, bValue;

//                 if (Array.isArray(dataIndex)) {
//                     aValue = dataIndex.reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : undefined, a);
//                     bValue = dataIndex.reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : undefined, b);
//                 } else {
//                     aValue = a[dataIndex];
//                     bValue = b[dataIndex];
//                 }

//                 if (aValue === undefined || aValue === null) aValue = '';
//                 if (bValue === undefined || bValue === null) bValue = '';

//                 if (typeof aValue === 'string') {
//                     return aValue.localeCompare(bValue, 'fa', { sensitivity: 'base' });
//                 }
//                 return aValue - bValue;
//             },
//             sortOrder: sortedInfo.columnKey === columnKey ? sortedInfo.order : null,
//         };
//     };

//     // --- تابع رندر برای ردیف توسعه یافته (Expanded Row Render Function) ---
//     const expandedRowRender = (record) => {
//         const totalPersons = (record?.factor?.personCount || 0) + (record?.factor?.extraPersonCount || 0) + (record?.factor?.childCount || 0);

//         return (
//             <Descriptions bordered column={{ xs: 1, sm: 2, md: 3 }} size="small" style={{ margin: '16px 0' }}>
//                 <Descriptions.Item label="دوره رزرو">
//                     <Tag color="blue">{record?.period?.title || "نامشخص"}</Tag>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="زیردوره رزرو">
//                     <Tag color="geekblue">{record?.subPeriod?.title || "نامشخص"}</Tag>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="تعداد نفرات">
//                     <Tag color="green">{totalPersons} نفر</Tag>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="تعداد شب اقامت">
//                     <Tag color="purple">{record?.factor?.nightCount || 0} شب</Tag>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="وضعیت رزرو غذا">
//                     <FoodAndParkingStatus foodAndParkingStatus={record.foodAndParkingStatus} />
//                 </Descriptions.Item>
//                 <Descriptions.Item label="تعداد پارکینگ">
//                     <Tag color="orange">{record?.Parking_Reserves?.count || 0}</Tag>
//                 </Descriptions.Item>
//                 {/* می‌توانید موارد بیشتری را اینجا اضافه کنید */}
//             </Descriptions>
//         );
//     };
//     // -----------------------------------------------------------------

//     const columns = [
//         {
//             title: 'ردیف',
//             key: 'rowNumber',
//             render: (text, record, index) => index + 1,
//             width: 50,
//             align: 'center',
//             ...getColumnSorter('rowNumber'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'کد پیگیری',
//             dataIndex: 'trackingCode',
//             key: 'trackingCode',
//             width: 100,
//             ...getColumnSorter('trackingCode'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'مکان رزرو',
//             dataIndex: ['objectInstance', 'title'],
//             key: 'objectInstanceTitle',
//             render: (title, record) => title || (objectInstance ? objectInstance.title : "نامشخص"),
//             width: 120,
//             ...getColumnSorter(['objectInstance', 'title']),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'کد ملی',
//             dataIndex: 'nationalCode',
//             key: 'nationalCode',
//             width: 100,
//             ...getColumnSorter('nationalCode'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'نام نفر اصلی',
//             dataIndex: 'fullName',
//             key: 'fullName',
//             width: 140,
//             ...getColumnSorter('fullName'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'موبایل',
//             dataIndex: 'mobile',
//             key: 'mobile',
//             width: 110,
//             ...getColumnSorter('mobile'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'شروع اقامت',
//             dataIndex: 'from_Shamsi',
//             key: 'from_Shamsi',
//             width: 100,
//             ...getColumnSorter('from_Shamsi'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'پایان اقامت',
//             dataIndex: 'to_Shamsi',
//             key: 'to_Shamsi',
//             width: 100,
//             ...getColumnSorter('to_Shamsi'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'وضعیت کلی رزرو',
//             dataIndex: 'reserveStatus',
//             key: 'reserveStatus',
//             render: (status) => <ReserveStatus reserveStatus={status} />,
//             width: 120,
//             ...getColumnSorter('reserveStatus'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         // ستون‌های زیر به expandedRowRender منتقل شدند:
//         // { title: 'تعداد نفرات', ... },
//         // { title: 'تعداد شب اقامت', ... },
//         // { title: 'دوره رزرو', ... },
//         // { title: 'زیردوره رزرو', ... },
//         // { title: 'وضعیت رزرو غذا', ... },
//         // { title: 'تعداد پارکینگ', ... },
//     ];

//     const filteredReserves = onlyByFoodOrParking
//         ? reserves.filter(reserve => reserve.period?.enableFoodReserve || reserve.period?.enableParkingReserve)
//         : reserves;

//     return (
//         <div className='container'>
//             <Table
//                 columns={columns}
//                 dataSource={filteredReserves}
//                 rowKey="id"
//                 onChange={handleChange}
//                 onRow={(record) => {
//                     return {
//                         onClick: () => {
//                             if (onItemClick) {
//                                 onItemClick(record.id);
//                             }
//                         },
//                         style: onItemClick ? { cursor: 'pointer' } : {},
//                         className: record.lotteryPriority == 1 ? 'successRow valueRow' : record.lotteryPriority > 1 ? 'failRow valueRow' : 'valueRow',
//                     };
//                 }}
//                 pagination={{
//                     pageSize: 10,
//                     showSizeChanger: true,
//                     pageSizeOptions: ['10', '20', '50', '100'],
//                     showTotal: (total, range) => `${range[0]}-${range[1]} از ${total} آیتم`,
//                 }}
//                 // --- اضافه کردن expandable property ---
//                 expandable={{ expandedRowRender }}
//             />
//         </div>
//     );
// };





// import React, { useState } from 'react';
// import { Table, Button, Space } from 'antd';
// import { ReserveStatus } from './ReserveStatus';
// import { FoodAndParkingStatus } from './FoodAndParkingStatus';

// const tableCellStyle = {
//     wordWrap: 'break-word',
//     wordBreak: 'break-word',
// };

// export const ReservesGrid = ({
//     reserves,
//     onlyByFoodOrParking = false,
//     objectInstance,
//     onItemClick,
// }) => {
//     const [sortedInfo, setSortedInfo] = useState({});

//     const handleChange = (pagination, filters, sorter) => {
//         setSortedInfo(sorter);
//     };

//     const getColumnSorter = (dataIndex) => {
//         const columnKey = Array.isArray(dataIndex) ? dataIndex.join('.') : dataIndex;

//         return {
//             sorter: (a, b) => {
//                 let aValue, bValue;

//                 if (Array.isArray(dataIndex)) {
//                     aValue = dataIndex.reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : undefined, a);
//                     bValue = dataIndex.reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : undefined, b);
//                 } else {
//                     aValue = a[dataIndex];
//                     bValue = b[dataIndex];
//                 }

//                 if (aValue === undefined || aValue === null) aValue = '';
//                 if (bValue === undefined || bValue === null) bValue = '';

//                 if (typeof aValue === 'string') {
//                     return aValue.localeCompare(bValue, 'fa', { sensitivity: 'base' });
//                 }
//                 return aValue - bValue;
//             },
//             sortOrder: sortedInfo.columnKey === columnKey ? sortedInfo.order : null,
//         };
//     };

//     const columns = [
//         {
//             title: 'ردیف',
//             key: 'rowNumber',
//             render: (text, record, index) => index + 1,
//             width: 50, // کاهش عرض
//             align: 'center',
//             ...getColumnSorter('rowNumber'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'کد پیگیری',
//             dataIndex: 'trackingCode',
//             key: 'trackingCode',
//             width: 90, // کاهش عرض
//             ...getColumnSorter('trackingCode'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'مکان رزرو',
//             dataIndex: ['objectInstance', 'title'],
//             key: 'objectInstanceTitle',
//             render: (title, record) => title || (objectInstance ? objectInstance.title : "نامشخص"),
//             width: 100, // کاهش عرض
//             ...getColumnSorter(['objectInstance', 'title']),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'کد ملی',
//             dataIndex: 'nationalCode',
//             key: 'nationalCode',
//             width: 100, // کاهش عرض
//             ...getColumnSorter('nationalCode'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'نام نفر اصلی',
//             dataIndex: 'fullName',
//             key: 'fullName',
//             width: 130, // کاهش عرض
//             ...getColumnSorter('fullName'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'موبایل', // عنوان کوتاه شد
//             dataIndex: 'mobile',
//             key: 'mobile',
//             width: 100, // کاهش عرض
//             ...getColumnSorter('mobile'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'شروع اقامت', // عنوان کوتاه شد
//             dataIndex: 'from_Shamsi',
//             key: 'from_Shamsi',
//             width: 90, // کاهش عرض
//             ...getColumnSorter('from_Shamsi'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'پایان اقامت', // عنوان کوتاه شد
//             dataIndex: 'to_Shamsi',
//             key: 'to_Shamsi',
//             width: 90, // کاهش عرض
//             ...getColumnSorter('to_Shamsi'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'نفرات', // عنوان کوتاه شد
//             key: 'personCountTotal',
//             render: (text, record) => (record?.factor?.personCount || 0) + (record?.factor?.extraPersonCount || 0) + (record?.factor?.childCount || 0),
//             width: 70, // کاهش عرض
//             align: 'center',
//             ...getColumnSorter('personCountTotal'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'شب اقامت', // عنوان کوتاه شد
//             dataIndex: ['factor', 'nightCount'],
//             key: 'nightCount',
//             render: (nightCount) => nightCount || 0,
//             width: 70, // کاهش عرض
//             align: 'center',
//             ...getColumnSorter(['factor', 'nightCount']),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'دوره', // عنوان کوتاه شد
//             dataIndex: ['period', 'title'],
//             key: 'periodTitle',
//             render: (title) => title || "نامشخص",
//             width: 100, // کاهش عرض
//             ...getColumnSorter(['period', 'title']),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'زیردوره', // عنوان کوتاه شد
//             dataIndex: ['subPeriod', 'title'],
//             key: 'subPeriodTitle',
//             render: (title) => title || "نامشخص",
//             width: 120, // کاهش عرض (با توجه به تصویر شما همچنان طولانی است)
//             ...getColumnSorter(['subPeriod', 'title']),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'وضعیت رزرو',
//             dataIndex: 'reserveStatus',
//             key: 'reserveStatus',
//             render: (status) => <ReserveStatus reserveStatus={status} />,
//             width: 100, // کاهش عرض
//             ...getColumnSorter('reserveStatus'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'وضعیت غذا', // عنوان کوتاه شد
//             dataIndex: 'foodAndParkingStatus',
//             key: 'foodAndParkingStatus',
//             render: (status) => <FoodAndParkingStatus foodAndParkingStatus={status} />,
//             width: 90, // کاهش عرض
//             ...getColumnSorter('foodAndParkingStatus'),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//         {
//             title: 'پارکینگ', // عنوان کوتاه شد
//             dataIndex: ['Parking_Reserves', 'count'],
//             key: 'parkingCount',
//             render: (count) => count || 0,
//             width: 70, // کاهش عرض
//             align: 'center',
//             ...getColumnSorter(['Parking_Reserves', 'count']),
//             onCell: () => ({ style: tableCellStyle }),
//         },
//     ];

//     const filteredReserves = onlyByFoodOrParking
//         ? reserves.filter(reserve => reserve.period?.enableFoodReserve || reserve.period?.enableParkingReserve)
//         : reserves;

//     return (
//         <div className='container'>
//             <Table
//                 columns={columns}
//                 dataSource={filteredReserves}
//                 rowKey="id"
//                 onChange={handleChange}
//                 onRow={(record) => {
//                     return {
//                         onClick: () => {
//                             if (onItemClick) {
//                                 onItemClick(record.id);
//                             }
//                         },
//                         style: onItemClick ? { cursor: 'pointer' } : {},
//                         className: record.lotteryPriority == 1 ? 'successRow valueRow' : record.lotteryPriority > 1 ? 'failRow valueRow' : 'valueRow',
//                     };
//                 }}
//                 pagination={{
//                     pageSize: 10,
//                     showSizeChanger: true,
//                     pageSizeOptions: ['10', '20', '50', '100'],
//                     showTotal: (total, range) => `${range[0]}-${range[1]} از ${total} آیتم`,
//                 }}
//                 // اگر حتی با این عرض‌های کم هم جدول بیرون زد،
//                 // ممکن است نیاز باشد برای ستون‌های خاصی width نگذارید
//                 // تا Ant Design بقیه فضای خالی را به آنها اختصاص دهد.
//                 // و یا به طور کلی راه حل‌های جایگزین را در نظر بگیرید.
//             />
//         </div>
//     );
// };







// import React, { useState } from 'react'
// import { Button, Col, Input, Pagination, Row } from 'antd'
// import { ReserveStatus } from './ReserveStatus';
// import { FoodAndParkingStatus } from './FoodAndParkingStatus';

// // =================================================================
// export const ReservesGrid = ({
//     reserves,
//     rowNumber,
//     onlyByFoodOrParking = false,
//     mode = "reserves",
//     objectInstance,
//     onItemClick,
//     // isShowFoodReserve = false,
//     // onFoodClick,
// }) => {
//     // =================================================================
//     return (
//         <>
//             {reserves.length > 0 ?
//                 <>
//                     <div className='container'>
//                         <Row className='titleRow'>
//                             <Col xs={3} sm={3} md={3} lg={1} xl={1} className='titleColumn'> ردیف </Col>
//                             <Col xs={3} sm={3} md={3} lg={2} xl={2} className='titleColumn'> پیگیری </Col>
//                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='titleColumn'> مکان </Col>
//                             <Col xs={4} sm={4} md={4} lg={2} xl={2} className='titleColumn'> کد ملی </Col>
//                             <Col xs={4} sm={4} md={4} lg={2} xl={2} className='titleColumn'> نفر اصلی </Col>
//                             <Col xs={4} sm={4} md={4} lg={2} xl={2} className='titleColumn'> موبایل </Col>
//                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='titleColumn'>شروع اقامت  </Col>
//                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='titleColumn'>   پایان اقامت </Col>
//                             <Col xs={4} sm={4} md={3} lg={1} xl={1} className='titleColumn'>   تعداد نفرات </Col>
//                             <Col xs={4} sm={4} md={3} lg={1} xl={1} className='titleColumn'>   تعداد شب </Col>
//                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='titleColumn'>  دوره </Col>
//                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='titleColumn'>  زیردوره </Col>

//                             <Col xs={5} sm={5} md={5} lg={2} xl={2} className='titleColumn'>
//                                 {mode == "reserves" ?
//                                     "وضعیت رزرو" : "وضعیت رزرو غذا"
//                                 }
//                             </Col>
//                             {/* {isShowFoodReserve ?
//                                 <Col xs={4} sm={4} md={3} lg={1} xl={1} className='titleColumn'>    </Col> : <></>
//                             } */}

//                         </Row>
//                         {
//                             reserves.map((reserve, key) =>
//                                 <>
//                                     {onlyByFoodOrParking &&
//                                         !reserve.period.enableFoodReserve &&
//                                         !reserve.period.enableParkingReserve ?
//                                         <></>
//                                         : <Row style={onItemClick ? { cursor: 'pointer' } : {}} onClick={() => onItemClick(reserve.id)} className={reserve.lotteryPriority == 1 ? 'successRow valueRow' : reserve.lotteryPriority > 1 ? 'failRow valueRow' : 'valueRow'}>
//                                             <Col xs={3} sm={3} md={3} lg={1} xl={1} className='valueColumn'>  {rowNumber++} </Col>
//                                             <Col xs={3} sm={3} md={3} lg={2} xl={2} className='valueColumn'>  {reserve.trackingCode} </Col>
//                                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='valueColumn'>{reserve.objectInstance ? reserve.objectInstance.title : objectInstance ? objectInstance.title : ""}</Col>
//                                             <Col xs={4} sm={4} md={4} lg={2} xl={2} className='valueColumn'> {reserve.nationalCode}  </Col>
//                                             <Col xs={4} sm={4} md={4} lg={2} xl={2} className='valueColumn'> {reserve.fullName}  </Col>
//                                             <Col xs={4} sm={4} md={4} lg={2} xl={2} className='valueColumn'> {reserve.mobile}  </Col>
//                                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='valueColumn'>{reserve.from_Shamsi}</Col>
//                                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='valueColumn'>{reserve.to_Shamsi}</Col>
//                                             <Col xs={4} sm={4} md={3} lg={1} xl={1} className='valueColumn'>{reserve?.factor?.personCount + reserve?.factor?.extraPersonCount + reserve?.factor?.childCount}</Col>
//                                             <Col xs={4} sm={4} md={3} lg={1} xl={1} className='valueColumn'>{reserve?.factor?.nightCount}</Col>
//                                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='valueColumn'>{reserve?.period?.title}</Col>
//                                             <Col xs={4} sm={4} md={3} lg={2} xl={2} className='valueColumn'>{reserve?.subPeriod?.title}</Col>

//                                             <Col xs={5} sm={5} md={5} lg={2} xl={2} className='valueColumn'>
//                                                 {mode == "reserves" ?

//                                                     <ReserveStatus reserveStatus={reserve.reserveStatus} /> :
//                                                     <FoodAndParkingStatus foodAndParkingStatus={reserve.foodAndParkingStatus} />
//                                                 }
//                                             </Col>
//                                             {/* {isShowFoodReserve ?
//                                                 <Col xs={4} sm={4} md={3} lg={1} xl={1} className='valueColumn'>
//                                                     <Button
//                                                         style={{ width: '98%' }}
//                                                         className='btn-primary'
//                                                         htmlType="submit"
//                                                         onClick={() => {if(onFoodClick)onFoodClick();}}>
//                                                         غذا
//                                                     </Button> </Col> : <></>
//                                             } */}
//                                         </Row>}
//                                 </>
//                             )}
//                     </div>

//                 </>

//                 : <></>
//             }

//         </>
//     )
// }

